import { ESVNet, ESVBase, ESVStorage } from 'esvcp-mobile';
import { wxCircle, wxFriends } from '@/base/share.js';
import { doRequest } from '@/http/http.js';
let title = '';
let link = '';
function getMerchantInfo() {
    window.getMerchantInfoTime = (new Date()).getTime();
    return new Promise((resolve, reject) => {
        doRequest(
            { url: '/merchant/getMerchantInfo', params: {} },
            function (data) {
                console.log('商户信息初始化');
                window.esvcp.store.commit(
                    'APP_MERCHANT_INFO',
                    data.result
                );
                const merchantCode = data.result.merchantCode;
                const url = window.location.href.split('#')[0] + '#/OPHomenew';
                title = data.result.wechantTitle;
                console.log(window.location.href, window.location.href.split('#')[1]);

                if (/OPHomenew/.test(window.location.href.split('#')[1])) {
                    document.title = data.result.wechantTitle;
                }
                resolve(data);

                getShortOauthUrl(url, merchantCode, title);
            // ESVStorage.putSessionValue('merchantInfo', data.result);
            },
            (err) => {
                resolve(err);
            }
        );
    });
}

function getShortOauthUrl(url, merchantCode) {
    window.getShortOauthUrlTime = (new Date()).getTime();
    ESVNet.doRequest(
        {
            url: '/oauth/getShortOauthUrl',
            params: {
                url,
                merchantCode
            }
        },
        function (data) {
            link = data.result;
            onMenuFriend();
            const baseSession = {
                merchantCode: merchantCode,
                link: link,
                wechatTitle: title
            };
            ESVStorage.putSessionValue('baseSession', baseSession);
        }
    );
}
export function onMenuFriend () {
    console.log('调用微信分享接口');
    wxCircle(title, link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg', 'home');
    wxFriends(title, '', link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg');
}
export const wxPromiseFunc = () => {
    return new Promise(resolve => {
        const doWxConfig = () => {
            window.doWxConfigTime = (new Date()).getTime();

            return new Promise(resolve => {
                const page = window.location.href.split('#')[0];
                ESVNet.doRequest(
                    {
                        url: window.esvcp.runtime.currentConfig.WxConfigApi,
                        params: {
                            opid: ESVBase.getPramVal('opId'),
                            url: page
                        }
                    },
                    data => {
                        const configObj = data.result;
                        const jsApiList = [
                            'chooseImage',
                            'uploadImage',
                            'onMenuShareTimeline',
                            'hideAllNonBaseMenuItem',
                            'previewImage',
                            'getLocation',
                            'chooseWXPay',
                            'getNetworkType',
                            'scanQRCode',
                            'chooseInvoiceTitle',
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                        ];
                        if (window.__wxjs_is_wkwebview === true) {
                            jsApiList.push('getLocalImgData');
                        }
                        wx.config({
                            beta: true,
                            debug: false,
                            appId: configObj.appId,
                            timestamp: configObj.timestamp,
                            nonceStr: configObj.nonce || configObj.nonceStr,
                            signature: configObj.signature,
                            jsApiList: jsApiList
                        });
                        resolve();
                        wx.ready(() => {
                            window.esvcp.store.commit(
                                'esvcp/ESVCP_LOAD_WX_CONFIG',
                                1
                            );
                        });

                        wx.error(res => {
                            window.esvcp.store.commit(
                                'esvcp/ESVCP_LOAD_WX_CONFIG',
                                2
                            );
                            resolve();
                        });
                    },
                    data => {
                        window.esvcp.store.commit(
                            'esvcp/ESVCP_LOAD_WX_CONFIG',
                            2
                        );
                        resolve();
                    },
                    () => {
                        window.esvcp.store.commit(
                            'esvcp/ESVCP_LOAD_WX_CONFIG',
                            2
                        );
                        resolve();
                    }
                );
            });
        };
        const doWxAuthenticate = () => {
            window.doWxAuthenticate = (new Date()).getTime();
            return new Promise(resolve => {
                if (
                    !ESVBase.isEmpty(
                        window.esvcp.runtime.currentConfig.WxAuthenticateApi
                    )
                ) {
                    let url;
                    if (
                        Array.isArray(
                            window.esvcp.runtime.currentConfig.WxAuthenticateApi
                        )
                    ) {
                        if (
                            ESVBase.getPramVal('esvOAuthUrlIndex') &&
                            ESVBase.getPramVal('esvOAuthUrlIndex') <
                                window.esvcp.runtime.currentConfig
                                    .WxAuthenticateApi.length
                        ) {
                            url =
                                window.esvcp.runtime.currentConfig
                                    .WxAuthenticateApi[ESVBase.getPramVal('esvOAuthUrlIndex')];
                        } else {
                            url =
                                window.esvcp.runtime.currentConfig
                                    .WxAuthenticateApi[0];
                        }
                    } else {
                        url =
                            window.esvcp.runtime.currentConfig
                                .WxAuthenticateApi;
                    }
                    ESVNet.doRequest(
                        {
                            url: url,
                            params: {
                                token: ESVBase.getPramVal('token')
                            }
                        },
                        data => {
                            window.esvcp.store.commit(
                                'APP_WX_AUTHENTICATE',
                                1
                            );
                            resolve();
                        },
                        data => {
                            resolve();
                        },
                        () => {
                            resolve();
                        }
                    );
                } else {
                    resolve();
                }
            });
        };
        doWxAuthenticate()
            .then(doWxConfig)
            .then(async() => {
                console.log('readyjsfjshfjhkjshfkjshfkjshfkjshfkjs');
                // 1 判断当前版本是否支持指定 JS 接口，支持批量判断
                wx.checkJsApi({
                    jsApiList: [
                        'updateAppMessageShareData',
                        'onMenuShareTimeline',
                        'updateTimelineShareData',
                        'onMenuShareQQ',
                        'chooseImage',
                        'uploadImage',
                        'onMenuShareWeibo',
                        'chooseWXPay'
                    ],
                    success: function(res) {
                        console.log('support: ' + JSON.stringify(res));
                    }
                });
                await getMerchantInfo();
                resolve();
                return '';
            })
            .catch(e => {
                resolve();
            });
    });
};

// ESVPlugin.setCommonWxPromiseFunc(wxPromiseFunc);
